import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SortableCategory = ({ id, name, onRemove, children, isOver, editMode }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners} className="mb-4 drag-handle">
            <div className={`rounded-md transition-all duration-200 ${
                isOver ? 'border-blue-400 bg-neutral-500/80 shadow-lg' : 'bg-neutral-800'
            }`}>
                <div className="flex justify-between items-center py-2">
                    <h2 className="text-3xl text-center mx-auto font-bold text-white">{name}</h2>
                    {editMode && (
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                onRemove();
                            }}
                            className="flex items-center h-8 w-8 justify-center text-red-500 cursor-pointer hover:text-red-300"
                            title="Remove Category"
                        >
                            <FontAwesomeIcon icon={'fas fa-trash'} size={'sm'}/>
                        </button>
                    )}
                </div>
                <div className="space-y-2 p-2">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default SortableCategory;
